import { Controller } from '@hotwired/stimulus'

// Repeatable label+URL link rows in the event composer (design 1c).
export default class extends Controller {
  static targets = ['list', 'row', 'template', 'timezone']

  connect () {
    if (this.hasTimezoneTarget) {
      this.timezoneTarget.value = Intl.DateTimeFormat().resolvedOptions().timeZone
    }
  }

  add () {
    const fragment = this.templateTarget.content.cloneNode(true)
    this.listTarget.appendChild(fragment)
  }

  remove (event) {
    event.target.closest('[data-event-links-target="row"]').remove()
  }
}
